export default __webpack_public_path__ + "static/0090-c933ca17d2be182191be17751cae7131.png";